<app-container
	type="light"
	[collapsable]="collapsable"
	[(collapsed)]="collapsed"
	[border]="collapsable ? highlightOnExpand : true"
	[titleTemplate]="titleTemplate"
	[highlightOnExpand]="highlightOnExpand"
>
	<hr [ngClass]="{ 'border-white': highlightOnExpand }" />
	<div *ngIf="financialInstitution" class="">
		<div
			class="ml-5 mt-2"
			*ngIf="
				financialInstitution?.address &&
				mortgageeType !== mortgageeTypes.COMPUTERSHARE
			"
		>
			<app-icon [icon]="ICON.LOCATION" class="text-grey-light mr-3"></app-icon>
			<span class="text-sm">{{ financialInstitution?.address | address }}</span>
		</div>
		<!-- When institution is not Computershare -->
		<div
			class="px-5 py-3"
			*ngIf="
				mortgageeType !== mortgageeTypes.COMPUTERSHARE && !hideContactDetails
			"
		>
			<div class="mb-3">
				<div class="flex mb-1 font-bold">
					<span *ngIf="!showDischargeFields">Contact details</span>
					<span *ngIf="showDischargeFields">Payout/discharge contact</span>
				</div>

				<app-payout-message
					*ngIf="showDischargeFields"
					[institution]="financialInstitution"
				></app-payout-message>
			</div>
			<ng-container *ngIf="institutionContactDetails">
				<app-contact-details-card
					(edit)="updateInstitution()"
					[contactDetails]="institutionContactDetails"
					[isEditable]="allowInstEdit"
					contactType="lender"
				>
				</app-contact-details-card>
				<app-container
					*ngIf="showInstitutionEscalation"
					title="Escalation"
					size="small"
					class="flex-col mt-6 container--dark"
					[collapsable]="true"
					[collapsed]="true"
				>
					<app-contact-details-card
						(edit)="updateInstitution()"
						[contactDetails]="escalationContactDetails"
						contactType="lender"
					>
					</app-contact-details-card>
				</app-container>
			</ng-container>
		</div>
		<hr [ngClass]="{ 'border-white': collapsable }" />

		<div
			class="px-5 pb-3"
			*ngIf="mortgageeType !== mortgageeTypes.COMPUTERSHARE"
		>
			<div
				class="mt-2 pt-2"
				*ngIf="
					financialInstitution?.type !== financialInstitutionTypes.TRUST_COMPANY
				"
			>
				<div class="flex items-center w-full">
					<ng-container *ngIf="financialInstitution?.branch">
						<span class="font-bold mr-4">Branch</span>
						<ui-button
							(click)="switchBranch()"
							label="Switch branch"
							icon="refresh"
						/>
					</ng-container>
					<div
						class="flex items-center w-full"
						*ngIf="!financialInstitution?.branch && !hideBranchSelector"
					>
						<span class="font-bold mr-4" *ngIf="!showDischargeFields"
							>Branch</span
						>
						<app-financial-institution-branch-search
							class="w-full"
							[financialInstitution]="financialInstitution"
							[fileType]="fileType"
							(onSelectedBranch)="onSelectedBranch($event)"
							[showDischargeFields]="showDischargeFields"
							[autoComplete]="showAddBranch"
							(toggleAddBranch)="toggleAddBranch()"
						>
						</app-financial-institution-branch-search>
					</div>
				</div>
			</div>

			<div class="pt-4" *ngIf="financialInstitution?.branch">
				<app-container class="p-2" type="clear">
					<div class="flex flex-col">
						<div class="font-bold flex items-center justify-between">
							<span class="mr-5">
								<span>
									{{
										financialInstitution?.branch?.name
											? financialInstitution?.branch?.name
											: 'Branch'
									}}
								</span>
							</span>
							<atomic-kebab-options
								*ngIf="
									mortgageeType !== mortgageeTypes.COMPUTERSHARE &&
									hideKebab !== true
								"
								[itemGroups]="[{ items: branchDropDownItems }]"
								(onSelect)="branchDropdownOptionSelect($event)"
							>
							</atomic-kebab-options>
						</div>
						<div class="text-sm mb-6">
							<span>{{ financialInstitution?.branch?.address | address }}</span>
						</div>
					</div>
					<ng-container *ngIf="!hideContactDetails">
						<app-contact-details-card
							(edit)="_editBranch()"
							[contactDetails]="branchContactDetails"
							contactType="branch"
						>
						</app-contact-details-card>
						<app-container
							*ngIf="showBranchEscalation"
							title="Escalation"
							size="small"
							class="flex-col mt-6 container--dark"
							[collapsable]="true"
							[collapsed]="true"
						>
							<app-contact-details-card
								(edit)="_editBranch()"
								[contactDetails]="branchEscalationContactDetails"
								contactType="branch"
							>
							</app-contact-details-card>
						</app-container>
					</ng-container>
				</app-container>
			</div>

			<div
				class="pt-4"
				*ngIf="
					financialInstitution?.type === financialInstitutionTypes.TRUST_COMPANY
				"
			>
				<div>
					<app-button
						class="my-2"
						btn="secondary"
						size="small"
						[icon]="ICON.ADD"
						(click)="toggleClientSearch()"
						>Add investors</app-button
					>
					<app-client-search
						createButtonLabel="Create new investor"
						placeholder="Search to add an investor"
						*ngIf="showClientSearch"
						(clientSelected)="onAddInvestor($event)"
						(add)="onCreateInvestor($event)"
					></app-client-search>
				</div>
				<ng-container *ngFor="let investor of financialInstitution?.investors">
					<app-investor-card
						class="my-2 block"
						[client]="associatedClientInvestors[investor]"
						(onRemoveLender)="removeInvestor(investor)"
					>
					</app-investor-card>
				</ng-container>
			</div>
		</div>

		<!-- When institution is Computershare -->
		<ng-container *ngIf="mortgageeType === mortgageeTypes.COMPUTERSHARE">
			<!-- When branch has not been selected -->
			<div
				*ngIf="!financialInstitution?.branch && !hideBranchSelector"
				class="flex flex-col py-5 px-3"
			>
				<div>
					<div>Select a lender</div>
					<div class="flex gap-3 py-5 flex-wrap">
						<ng-container *ngFor="let lender of popularCSLenders">
							<div
								class="p-2 cursor-pointer hover:shadow-md flex items-center justify-center w-24"
								(click)="setLeadingCSLender(lender.institutionId)"
							>
								<img [src]="'/assets/images/banks/' + lender.logo" />
							</div>
						</ng-container>
					</div>
					<span class="pb-5">Or search here</span>
				</div>
				<app-financial-institution-branch-search
					[financialInstitution]="financialInstitution"
					[showDischargeFields]="showDischargeFields"
					[fileType]="fileType"
					[mortgageeType]="mortgageeType"
					[autoComplete]="true"
					(onSelectedBranch)="onSelectedBranch($event)"
				>
				</app-financial-institution-branch-search>
			</div>
			<!-- When branch has been selected  -->
			<div
				*ngIf="financialInstitution?.branch"
				class="flex flex-col px-5 py-3 gap-4"
			>
				<app-container type="clear" class="p-2">
					<div class="mb-4">
						<div class="flex justify-between">
							<div class="flex items-center">
								<app-icon
									*ngIf="!financialInstitution?.branch.logoUrl"
									[icon]="ICON.MORTGAGE"
									class="text-2xl text-grey"
								></app-icon>
								<img
									*ngIf="financialInstitution?.branch.logoUrl"
									class="max-h-10"
									style="max-width: 85px"
									[src]="
										'/assets/images/banks/' +
										financialInstitution?.branch.logoUrl
									"
								/>

								<div class="flex flex-col justify-items-start ml-5">
									<h6 class="text-lg break-words font-bold">
										{{
											{
												name: financialInstitution?.branch.name,
												type: clientType.CORPORATION,
											} | clientName
										}}
									</h6>
								</div>
							</div>
							<!-- <atomic-kebab-options
								[itemGroups]="[{items: computerShareLenderDropdownItems}]"
								(onSelect)="branchDropdownOptionSelect($event)">
							</atomic-kebab-options> -->
						</div>
						<div class="mt-2" *ngIf="financialInstitution?.branch.address">
							<span class="text-sm">{{
								financialInstitution?.branch.address | address
							}}</span>
						</div>
					</div>
					<ng-container *ngIf="!hideContactDetails">
						<div class="flex mb-3">
							<p *ngIf="!showDischargeFields" class="font-bold">
								Contact details
							</p>
							<p *ngIf="showDischargeFields" class="font-bold">
								Payout/discharge contact
							</p>
						</div>

						<app-payout-message
							*ngIf="showDischargeFields"
							[institution]="financialInstitution"
							[branchId]="financialInstitution?.branch?.id"
						></app-payout-message>
						<app-contact-details-card
							(edit)="_editBranch()"
							[contactDetails]="branchContactDetails"
							contactType="lender"
						>
						</app-contact-details-card>
						<app-container
							*ngIf="showBranchEscalation"
							title="Escalation"
							size="small"
							class="flex-col mt-6 container--dark"
							[collapsable]="true"
							[collapsed]="true"
						>
							<app-contact-details-card
								(edit)="_editBranch()"
								[contactDetails]="branchEscalationContactDetails"
								contactType="lender"
							>
							</app-contact-details-card>
						</app-container>
					</ng-container>
				</app-container>
			</div>
		</ng-container>
	</div>
</app-container>

<ng-template #titleTemplate let-collapsed="collapsed">
	<!-- Institution Heading -->
	<div
		class="p-2 cursor-pointer border border-grey-veryLight rounded"
		[ngClass]="{
			'hover:border-blue-lightest hover:bg-blue-lightest': collapsable
				? collapsed
				: false,
			'border-none': highlightOnExpand ? !collapsed : false,
			'border-t border-b-0 border-l-0 border-r-0 cursor-default': !collapsable,
		}"
		(click)="toggleCollapsed()"
	>
		<div class="flex justify-between">
			<div class="flex items-center">
				<app-institution-img
					[financialInstitution]="financialInstitution"
				></app-institution-img>

				<div class="flex flex-col justify-items-start ml-5">
					<h5 class="font-semibold">{{ financialInstitution?.name }}</h5>
					<div *ngIf="primary">
						<app-pill class="mt-2" mode="secondary" size="xsmall"
							>Primary lender</app-pill
						>
					</div>
				</div>
			</div>

			<div class="flex items-center">
				<app-icon
					*ngIf="collapsable"
					class="mx-2 cursor-pointer"
					[icon]="collapsed ? ICON.DOWN : ICON.UP"
				></app-icon>

				<atomic-kebab-options
					(click)="$event.stopPropagation()"
					*ngIf="
						mortgageeType !== mortgageeTypes.COMPUTERSHARE && hideKebab !== true
					"
					[itemGroups]="[{ items: institutionDropDownItems }]"
					(onSelect)="dropdownOptionSelect($event)"
				>
				</atomic-kebab-options>

				<atomic-kebab-options
					(click)="$event.stopPropagation()"
					*ngIf="
						mortgageeType === mortgageeTypes.COMPUTERSHARE && hideKebab !== true
					"
					[itemGroups]="[{ items: computerShareDropdownItems }]"
					(onSelect)="dropdownOptionSelect($event)"
				>
				</atomic-kebab-options>
			</div>
		</div>
	</div>
</ng-template>
